import Highcharts from "highcharts/highstock";
import { default as hv } from "highcharts-vue";
const HighchartsVue = hv.default; // This is necessary due to changes in vite 8

// Highcharts' pointer keeps refs to points/series across chart.update()
// (highcharts-vue deep-watches options and rebuilds series). A destroyed
// point has point.series === undefined, and the next mousemove/redraw then
// crashes in runPointActions/setState/reset and leaves the chart frozen.
// Drop stale refs at the two pointer entry points instead of patching every
// component that updates a chart.
const dropStaleHoverRefs = (chart) => {
  if (!chart) return;
  if (chart.hoverPoint && !chart.hoverPoint.series) chart.hoverPoint = null;
  if (
    chart.hoverSeries &&
    (chart.hoverSeries.destroyed || !chart.hoverSeries.chart)
  ) {
    chart.hoverSeries = null;
  }
  if (chart.hoverPoints) {
    const alive = chart.hoverPoints.filter((p) => p.series);
    chart.hoverPoints = alive.length ? alive : null;
  }
};
["reset", "runPointActions"].forEach((fn) => {
  Highcharts.wrap(
    Highcharts.Pointer.prototype,
    fn,
    function (proceed, ...args) {
      dropStaleHoverRefs(this.chart);
      return proceed.apply(this, args);
    },
  );
});

// Set global Highcharts options
Highcharts.setOptions({
  lang: {
    thousandsSep: ",",
  },
  time: {
    useUTC: false,
  },
});

// Configure HighchartsVue with Highcharts instance (includes Stock)
const HighchartsVuePlugin = {
  install(app) {
    app.use(HighchartsVue, { highcharts: Highcharts });
  },
};

export { Highcharts, HighchartsVuePlugin as HighchartsVue };
